export const GET_MAP_DATA = 'GET_MAP_DATA';
export const SET_MAP_DATA = 'SET_MAP_DATA';
